import { EventInput } from "@fullcalendar/core";

import Activity from "@mapmycustomers/shared/types/entity/Activity";

import { formatDate } from "@app/util/formatters";
import isValidDate from "@app/util/isValidDate";
import { parseApiDate } from "@app/util/parsers";

import EventObject from "../type/EventObject";

const activityToEvent = (activity: Activity): EventInput => {
  const result: EventInput = {
    id: String(activity.id),
    allDay: activity.allDay,
    className: `act_${activity.id}`,
    editable: activity.accessStatus?.update !== false,
    end: activity.endAt ?? undefined,
    extendedProps: {
      activity,
    } as EventObject,
    resourceEditable: activity.accessStatus?.update !== false,
    resourceId: String(activity.assignee?.id),
    start: activity.startAt ?? undefined,
    title: activity.name ?? activity.note,
  };

  // for allDay activity, let's ensure that end date is not defined and that start date
  // will be of a correct date, taking user's TZ into account
  if (activity.allDay) {
    const startAt = activity.startAt ? parseApiDate(activity.startAt) : undefined;
    result.start = isValidDate(startAt) ? formatDate(startAt, "yyyy-MM-dd") : undefined;
    result.end = undefined;
  }

  return result;
};

export default activityToEvent;
